export function defineTargetEls(constructor) {
  const prototype = constructor.prototype;
  const targetNames = getTargetNamesForConstructor(constructor);
  targetNames.forEach(name => defineLinkedProperties(prototype, {
    ["".concat(name, "El")]: {
      get() {
        const target = this.targets.find(name);

        if (target) {
          return target;
        }

        console.info("Missing target element \"".concat(this.identifier, ".").concat(name));
      }

    },
    ["".concat(name, "Els")]: {
      get() {
        return this.targets.findAll(name);
      }

    },
    ["has".concat(capitalize(name), "El")]: {
      get() {
        return this.targets.has(name);
      }

    }
  }));
  buildSelectors(prototype, targetNames);
}

function getTargetNamesForConstructor(constructor) {
  const ancestors = getAncestorsForConstructor(constructor);
  return Array.from(ancestors.reduce((targetNames, constructor) => {
    getOwnTargetNamesForConstructor(constructor).forEach(name => targetNames.add(name));
    return targetNames;
  }, new Set()));
}

export function getAncestorsForConstructor(constructor) {
  const ancestors = [];

  while (constructor) {
    ancestors.push(constructor);
    constructor = Object.getPrototypeOf(constructor);
  }

  return ancestors;
}

function getOwnTargetNamesForConstructor(constructor) {
  const definition = constructor['targets'];
  return Array.isArray(definition) ? definition : [];
}

function defineLinkedProperties(object, properties) {
  Object.keys(properties).forEach(name => {
    if (!(name in object)) {
      const descriptor = properties[name];
      Object.defineProperty(object, name, descriptor);
    }
  });
}

function capitalize(name) {
  return name.charAt(0).toUpperCase() + name.slice(1);
}

function buildSelectors(object, targets) {
  if (!('selectors' in object)) {
    Object.defineProperty(object, 'selectors', {
      get() {
        return targets.reduce((selectors, target) => {
          selectors[target] = "[".concat(this.context.schema.elAttribute, "=\"").concat(this.context.identifier, ".").concat(target, "\"]");
          return selectors;
        }, {});
      }

    });
  }
}